import React, { useEffect, useState } from 'react';
import { ArrowRightIcon, LockIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
const INVESTOR_PASSWORD = 'ProtectYourFamily2026!';
const STORAGE_KEY = 'caveo_investor_auth';
export function InvestorAuthGate({
  children
}: {
  children: React.ReactNode;
}) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored === 'true') {
      setIsAuthenticated(true);
    }
  }, []);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === INVESTOR_PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, 'true');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password. Please try again.');
      setPassword('');
    }
  };
  if (isAuthenticated) {
    return <>{children}</>;
  }
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4" data-id="element-284">
      <div className="w-full max-w-md" data-id="element-285">
        <div className="text-center mb-8" data-id="element-286">
          <img src="https://cdn.magicpatterns.com/uploads/u2RsmpFkExbV8oAVAJrtqh/Caveo-Lockup-FC.png" alt="Caveo" className="h-8 mx-auto mb-6" data-id="element-287" />
          <div className="w-12 h-12 bg-[#f0ebf8] rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-288">
            <LockIcon size={22} className="text-[#631bb7]" data-id="element-289" />
          </div>
          <h1 className="text-2xl font-bold text-[#111111] mb-2" data-id="element-290">
            Investor Portal
          </h1>
        </div>

        <form onSubmit={handleSubmit} className="bg-white rounded-xl border border-gray-200 shadow-sm p-6 space-y-4" data-id="element-291">
          <div data-id="element-292">
            <label htmlFor="investor-password" className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-293">
              Password
            </label>
            <div className="relative" data-id="element-294">
              <input id="investor-password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => {
              setPassword(e.target.value);
              setError('');
            }} placeholder="Enter investor password" className="w-full px-4 py-3 pr-11 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-[#631bb7] focus:border-transparent transition-all" autoFocus data-id="element-295" />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors bg-transparent border-0 cursor-pointer p-0" data-id="element-296">
                {showPassword ? <EyeOffIcon size={18} data-id="element-297" /> : <EyeIcon size={18} data-id="element-298" />}
              </button>
            </div>
            {error && <p className="text-red-500 text-xs mt-2" data-id="element-299">{error}</p>}
          </div>

          <button type="submit" className="w-full bg-[#631bb7] text-white py-3 rounded-lg font-semibold text-sm hover:bg-[#521099] transition-colors flex items-center justify-center gap-2 border-0 cursor-pointer" data-id="element-300">
            Access Portal
            <ArrowRightIcon size={16} data-id="element-301" />
          </button>
        </form>
      </div>
    </div>;
}